import React, { useState } from "react";
import { ExternalLink } from "lucide-react";

interface ProjectItemProps {
  name: string;
  dateAdded: string;
  size: string;
  url?: string;
  contentUrl?: string;
  description?: string;
}

const ProjectItem: React.FC<ProjectItemProps> = ({
  name,
  dateAdded,
  size,
  url,
  contentUrl,
  description,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  return (
    <div className="project-item-wrapper">
      <div className="folder-item nested-item project-item">
        <span className="name-column">
          <span>{name}</span>
          {url && (
            <button
              className="project-action-button"
              onClick={handleLinkClick}
              title="Visit project"
            >
              <ExternalLink size={14} />
            </button>
          )}
        </span>
        <span>{dateAdded}</span>
        <span>{size}</span>
        <span></span>
      </div>

      {(description || (contentUrl && !imageError)) && (
        <div className="project-details">
          {description && <p className="project-description">{description}</p>}
          {contentUrl && !imageError && (
            <div className="project-image-container">
              <img
                src={contentUrl}
                alt={name}
                className="project-image"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{ display: imageLoaded ? "block" : "none" }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectItem;
